import React, { useState } from 'react';
import GenericModal from '../../../components/modal/GenericModal';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { quitarAsignacionVacanteAPI } from '../../../consumers/backendApisUrls';
import { ESTADOS_FIRMA_TP } from '../../../constants/hardCodedConstants';

// ──────────────────────────────────────────────────────────────────────────
// Confirmación de "Quitar asignación" de un participante de una convocatoria
// Masiva. POST TrasladosPromociones/QuitarAsignacionVacante (el id viaja en el
// body): libera la vacante reservada y devuelve al participante un paso atrás, a "Apto"
// en la etapa anterior a la asignación (Feedback Dirección en Traslado, Entrevista en
// Promoción; queda la huella en la auditoría de estados), con lo que GDH puede volver a
// asignar la vacante (a otro candidato o al mismo).
// Las reglas las valida el lambda; el ícono se ofrece en cualquier punto una vez
// asignada la vacante (row.puedeQuitarAsignacion): firma pendiente, enviada,
// observada o traslado cerrado. En esos tres últimos el lambda además anula la firma
// (queda en el historial) y, si estaba cerrado, reabre la vacante; el modal lo avisa.
// ──────────────────────────────────────────────────────────────────────────
const AVISO_POR_ESTADO = {
    [ESTADOS_FIRMA_TP.ENVIADA]: 'El colaborador ya envió su documento firmado: esa firma quedará anulada (se conserva en el historial) y tendrá que firmar de nuevo la nueva asignación.',
    [ESTADOS_FIRMA_TP.OBSERVADA]: 'El documento está observado: esa firma quedará anulada (se conserva en el historial) y tendrá que firmar de nuevo la nueva asignación.',
    [ESTADOS_FIRMA_TP.CERRADO]: 'El traslado ya fue cerrado: la firma quedará anulada (se conserva en el historial) y la vacante se reabrirá. Si el cambio ya se aplicó fuera de la intranet, no se revierte desde aquí.',
};

const QuitarAsignacionModal = ({ toggleModal, refreshPage, postulante }) => {
    const aviso = AVISO_POR_ESTADO[postulante.idEstado];
    // Misma regla que el lambda (quitarAsignacionMasivo): Traslado ("T") vuelve a Feedback
    // Dirección; Promoción, a Entrevista.
    const etapaAnterior = postulante.tipoProceso === 'T' ? 'Feedback Dirección' : 'Entrevista';
    const [managePostRequest] = useManagePostRequest();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        managePostRequest(
            quitarAsignacionVacanteAPI(),
            { IdPostulante: postulante.idPostulante },
            () => {
                setIsSubmitting(false);
                toggleModal();
                refreshPage && refreshPage();
            },
            true,
            () => setIsSubmitting(false),
            true
        );
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Quitar asignación" width="600px">
            <div className="modal-body pt-0">
                <div className="container-fluid">
                    Se va a quitar la asignación de vacante de:
                    <ul>
                        <li><strong>{postulante.nombrePostulante}</strong></li>
                        {postulante.nombreConvocatoria && <li>Convocatoria: {postulante.nombreConvocatoria}</li>}
                    </ul>
                    La vacante volverá a estar disponible y el participante regresará a
                    <strong> Apto</strong> en la etapa anterior (<strong>{etapaAnterior}</strong>),
                    para que puedas asignar nuevamente la vacante.
                    {aviso && <div className="mt-2"><strong>Atención:</strong> {aviso}</div>}
                    <br />
                    ¿Está seguro de esta acción?
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary generic-button-ficha-outlined"
                    disabled={isSubmitting}
                    onClick={() => toggleModal()}>
                    Volver
                </button>
                <button
                    type="button"
                    className="btn btn-primary generic-button-ficha mr-2"
                    disabled={isSubmitting}
                    onClick={handleSubmit}>
                    Quitar asignación
                </button>
            </div>
        </GenericModal>
    )
}

export default QuitarAsignacionModal
